/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { humanize } from "uno-js";
import { toast } from "react-hot-toast";
import { UPDATE_PAYMENT_RECEIPT } from "../pages/DoftApplicationDetails/graphql/updatePaymentReceipt.mutation";
import { string } from "yup";

const MODULE_NAME = "UpdatePaymentReceiptService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class UpdatePaymentReceiptService {
    private static instance: UpdatePaymentReceiptService;
    private vapp: VApplication;
    private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL = props?.termsURL;
    }
    public static getInstance(props: any = {}): UpdatePaymentReceiptService {
        if (!UpdatePaymentReceiptService.instance) {
            UpdatePaymentReceiptService.instance =
                new UpdatePaymentReceiptService(props);
        }
        return UpdatePaymentReceiptService.instance;
    }

    async updatePaymentReceipt(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `Update Payment Receipt  data in service`, data);
        // const paymentReceipt = {
        //     applicationId: "1234567",
        //     familyName: "familyName",
        //     givenName: "givenName",
        //     receiptId: data.receipt,
        //     transactionDate: data.date,
        //     transactionAmount: data.payment,
        //     receiptCopyURL: data.uploaddoftreceipt,
        // };

        // const Preciept = {
        //     applicationId: "1653813885262",
        //     familyName: "familyName",
        //     givenName: "givenName",
        //     receiptId: "12345",
        //     transactionDate: "31/05/2022",
        //     transactionAmount: "1000",
        //     modeOfPayment: "CASH",
        //     place: "BANK",
        //     receiptCopyURL:  ""
        // }

        
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: UPDATE_PAYMENT_RECEIPT,
                    variables:{input:data} ,
                    fetchPolicy: "no-cache",
                });
                log.success(
                    MODULE_NAME,
                    "Update payment Receipt result : ",
                    res
                );
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
